module.exports = __webpack_public_path__ + "img/im_pizza@2x.d929c3d7.png";